export default __webpack_public_path__ + "static/media/wallet-preview.c877d206.jpg";